/**
 * Types de pointage
 * @description Définit les types de pointage utilisés dans l'application
 */

export const CLOCKING_TYPES = {
  /**
   * Prise de service (Clock In)
   * @value 0
   */
  CLOCK_IN: 0,

  /**
   * Fin de service (Clock Out)
   * @value 1
   */
  CLOCK_OUT: 1,

  /**
   * Début de pause (Break Start)
   * @value 2
   */
  BREAK_START: 2,

  /**
   * Fin de pause (Break End)
   * @value 3
   */
  BREAK_END: 3,

  /**
   * Pré-pointage (Pre Clocking)
   * @value 4
   */
  PRE_CLOCKING: 4
} as const;

export default CLOCKING_TYPES;

/**
 * Type TypeScript pour les valeurs de CLOCKING_TYPES
 */
export type ClockingType = (typeof CLOCKING_TYPES)[keyof typeof CLOCKING_TYPES];

